import React from 'react';
import { LOGO_IMAGE, party } from '../data/party';
export function Footer() {
  return <footer className="w-full bg-[var(--night)] px-5 py-12 text-center" data-id="element-10" data-mp="3gfsnkey6wyo1">
      <img src={LOGO_IMAGE} alt="Kanchella" className="mx-auto block w-full max-w-sm invert" data-id="element-11" data-mp="3gh3swj7aaeh9" />
      <p className="font-poster mt-5 text-[var(--gold)] uppercase tracking-[0.3em]" data-id="element-12" data-mp="36oxyl2tk7kyw">
        {party.dateLong}, {party.year}
      </p>
      <p className="mt-6 text-sm text-white/40" data-id="element-13" data-mp="3ugbpd4c2b8hr">
        {party.venueAddress} · A play on Coachella, made with love 🌴
      </p>
    </footer>;
}